import { Guid } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicBrandCosmeticBox } from './public-brand-cosmetic-box';

export class PublicBrandCosmetic {
  public constructor(
    private readonly data: {
      boxes: PublicBrandCosmeticBox[];
      featuredFile: Multimedia;
      id: Guid;
      name: string;
      slug: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get featuredFile(): Multimedia {
    return this.data.featuredFile;
  }

  public get boxes(): PublicBrandCosmeticBox[] {
    return this.data.boxes;
  }
}
